<div class="terms-container">
  <div [innerHTML]="'Copyright' | cpLabelTranslate:['© ' + copyrightYear]  | async | cpBoldText:'© \\d+ Koninklijke Philips N.V.'"></div>
  <div class="terms-section" *ngIf="isNonMedicalDevice">{{'NonDiagnosticStatement' | cpLabelTranslate | async}}</div>
  <div class="terms-section" *ngIf="isUnreleasedDevice">{{'WarrantyDisclaimer' | cpLabelTranslate:['Workflow Information Management', releaseVersion] | async}}</div>


  <div class="terms-section">
      <img class="consult-symbol" [src]="'./assets/consult.png'">
      <a class="consult-link" href="https://www.philips.com/IFU" target="_blank">eIFU</a>
      <img class="caution-symbol" [src]="'./assets/caution.png'" />
      <span *ngIf="isUnreleasedDevice"  class="caution-text" >{{'EvaluationPurposes' | cpLabelTranslate | async}}</span>
  </div>
</div>
